export default __webpack_public_path__ + "static/media/3.5e40333a.gif";